$(function () {
  /*header*/
  var flag = false;
  var x = 768;
  var w,h;
  $(window).on('load resize', function(){
    w = $(window).width();
    h = $(window).height();

    if (w < x) {
      h = w;
    }
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() >= h && !$("header").hasClass("top")) {
      if (flag == false) {
        flag = true;
        $("header").addClass("fixed");
        /* $("#shopify-pc__banner").css({ "opacity": 1, "visibility":"visible"}); */
      }
    } else {
      if (flag == true) {
        flag = false;
        $("header").removeClass("fixed");
      }
    }
  });

  /* scroll animation */
  $(window).on('load scroll', function(){
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    $(".item").each(function(){
      var offsetTop = $(this).offset().top;
      if (scrollTop >= 0 && scrollTop > offsetTop - windowHeight + 50){
        $(this).addClass("is-view");
      }
    });
  });

  /* news ticker */
  $(".ticker_slide").slick({
    speed: 1000,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    dots: false,
    autoplay: true,
    waitForAnimate: false,
    autoplaySpeed: 5000
  });

  /* top slide  */
  $(".top_slide").slick({
    infinite: true,
    fade: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false
  });

  /* product animation */
  $(".product_slide").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(".slick-slide").click(function(){
    $(".product_slide").slick('slickNext');
  });

  /* variation slide  */
  $(".variation_slide").slick({
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });

  /* limited_slide  */
  $(".limited_slide").slick({
    infinite: true,
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: $(".limited_slide li").length > 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          vertical: true,
          slidesToShow: $(".limited_slide li").length,
          slidesToScroll: 1,
          fade: false,
          dots: false
        }
      }
    ]
  });

  /* pickup slide  */
  $(".pickup_slide").slick({
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: true,
    centerMode: true,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          centerMode: false
        }
      }
    ]
  });

  const pickup = document.querySelector(".pickup");
  const observer = new IntersectionObserver(function(entries) {
    for(const e of entries) {
      if(e.isIntersecting) {
        $(".pickup_slide").slick('slickPlay');
      } else{
        $(".pickup_slide").slick('slickPause');
      }
    }
  });
  if($(".pickup").length > 0){
    observer.observe(pickup);
  }

  /* recommend slide */
  $(".recommend_list").slick({
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    centerMode: true,
    centerPadding: 0,
    waitForAnimate: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  /* column slide */
  $(".story .story_list").slick({
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    appendArrows: $('.arrows'),
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    waitForAnimate: false,
    dots: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(".article_related .story_list").slick({
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    waitForAnimate: false,
    dots: false,
    arrows: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          settings: 'unslick'
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $(window).on('resize orientationchange', function() {
    $('.js-slider').slick('resize');
  });

  /* menu */
  $(".menu_btn").click(function () {
    current_scrollY = $( window ).scrollTop();
    $("header").toggleClass("open");
    $("#menu").fadeIn("slow");
    if(!$("header").hasClass("open")){
      $("#menu").fadeOut("fast");
    }
  });

  $('a[href="#recover"]').on("click", function() {
    $("#recover").addClass("reset");
    return false;
  });
  $(".cancel").on("click", function() {
    $("#recover").removeClass("reset");
  });
  $('input').bind("keydown", function(e) {
    var n = $("input").length;
    if (e.which == 13){
      e.preventDefault();
      var nextIndex = $('input').index(this) + 1;
      if(nextIndex < n) {
        $('input')[nextIndex].focus();
      } else {
        $('input')[nextIndex-1].blur();
      }
    }
  });

  /* input text count */
  $(".input_limit input").on("load change", function(){
    var str = $(this).val();
    str = str.replace( /[A-Za-z0-9-!"#$%&'()=<>,.?_\[\]{}@^~\\]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) + 65248);
    });

    var beforeStr = new Array('ｧ','ｨ','ｩ','ｪ','ｫ','ｬ','ｭ','ｮ','ｯ','ｰ','ｳﾞ','ｶﾞ','ｷﾞ','ｸﾞ','ｹﾞ','ｺﾞ','ｻﾞ','ｼﾞ','ｽﾞ','ｾﾞ','ｿﾞ','ﾀﾞ','ﾁﾞ','ﾂﾞ','ﾃﾞ','ﾄﾞ','ﾊﾞ','ﾋﾞ','ﾌﾞ','ﾍﾞ','ﾎﾞ','ﾊﾟ','ﾋﾟ','ﾌﾟ','ﾍﾟ','ﾎﾟ','ｱ','ｲ','ｳ','ｴ','ｵ','ｶ','ｷ','ｸ','ｹ','ｺ','ｻ','ｼ','ｽ','ｾ','ｿ','ﾀ','ﾁ','ﾂ','ﾃ','ﾄ','ﾅ','ﾆ','ﾇ','ﾈ','ﾉ','ﾊ','ﾋ','ﾌ','ﾍ','ﾎ','ﾏ','ﾐ','ﾑ','ﾒ','ﾓ','ﾔ','ﾕ','ﾖ','ﾗ','ﾘ','ﾙ','ﾚ','ﾛ','ﾜ','ｦ','ﾝ');
    var afterStr = new Array('ァ','ィ','ゥ','ェ','ォ','ャ','ュ','ョ','ッ','ー','ヴ','ガ','ギ','グ','ゲ','ゴ','ザ','ジ','ズ','ゼ','ゾ','ダ','ヂ','ヅ','デ','ド','バ','ビ','ブ','ベ','ボ','パ','ピ','プ','ペ','ポ','ア','イ','ウ','エ','オ','カ','キ','ク','ケ','コ','サ','シ','ス','セ','ソ','タ','チ','ツ','テ','ト','ナ','ニ','ヌ','ネ','ノ','ハ','ヒ','フ','ヘ','ホ','マ','ミ','ム','メ','モ','ヤ','ユ','ヨ','ラ','リ','ル','レ','ロ','ワ','ヲ','ン');

    for(var i = 0; i < beforeStr.length; i++) {
      str = str.replace(new RegExp(beforeStr[i], 'g'), afterStr[i]);
    }

    $(this).val(str);
    var txtcount = $(this).val().length;
    $(this).next(".limit_num").text(txtcount);
    if(txtcount >= 16){
      $(this).parent().addClass("error");
    } else {
      $(this).parent().removeClass("error");
    }
  });
  $(".input_limit input").trigger('load');

  /* input validation */
  $('.cart_btn input[type="submit"]').on('click', function (e) {
    if (e.metaKey || e.ctrlKey) {
      e.preventDefault();
      $(this).parent("form").submit();
    }
    $(this).prop('disabled', true);
    $(this).parent("form").submit();
  });
  $('.form input[type="button"]').click(function() {
    var isRequired = 0;
    $(this).parent("form").find("input[required],.input_limit input[required], select[required]").each(function(i, form) {
      if(!$(form).val() || $(this).children("option:selected").val() == "") {
        $(form).css('box-shadow','0 0 0 2px #b93636');
        $("html, body").animate({scrollTop: 50}, 'fast');
        isRequired++;
      } else {
        $(form).removeAttr("style");
      }
    });
    if(isRequired == 0){
      $(this).parent("form").submit();
    }else{
      if(!$('.error_form').length){
        $(this).parent("form").siblings(".required_error").append('<p class="error_form">必ず入力してください</p>').show();
      }
    }
  });

  /* guide */
  $('.guide .inner >h2:not(.open), .shopping_guide >h2:not(.open)').nextUntil('h2').css({
    "height": 0,
    "opacity": 0,
    "margin":0,
    "visibility":"hidden"
  });
  $('.guide .inner >h2, .shopping_guide >h2').on('click', function(){
    $(this).nextUntil('h2').removeAttr('style');
    if($(this).hasClass("open")){
      $(this).nextUntil('h2').css({
        "height": 0,
        "opacity": 0,
        "margin":0,
        "visibility":"hidden"
      });
    }else{
      $(this).nextUntil('h2').removeAttr('style');
    }
    $(this).toggleClass("open");
  });
  $('.guide a[href^="#"]').on("click", function() {
    if(!$($(this).attr("href")).prevAll("h2:first").hasClass("open")){
      $($(this).attr("href")).prevAll("h2:first").click();
    }
    $("html,body").animate({ scrollTop: $($(this).attr("href")).offset().top-80 }, "slow");
    return false;
  });
  $(window).on('load', function() {
    var url = $(location).attr('href');
    if(url.indexOf("#") != -1){
      var anchor = url.split("#");
      var target = $('#' + anchor[anchor.length - 1]);
      if(target.length){
        var pos = Math.floor(target.offset().top) - 80;
        $("html, body").animate({scrollTop:pos}, 0);
      }
    }
  });
  /* article table of contents */
  var counter = 1;
  var topics = $(".story_content h2").length;
  if(topics > 2){
    $(".story_summary").after('<div class="story_topics"><h3>TOPICS</h3><ul class="topics_list"></ul></div>');
    $(".story_content h2").each(function() {
      var topic = "topic" + counter;
      $(this).attr("id", topic);
      var toctext = $(this).text();
      var element = "<li><a href='#" + topic + "'>" + toctext + "</a></li>";
      $(".topics_list").append(element);
      counter++;
    });
  }
  $('.story_content a[href^="#"]').click(function(){
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-80;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  /* Instagram modal */
  $(document).on("click", "#slpht-close", function(){
    setTimeout(function () {
      window.scrollTo(0, $(".instagram_feed").offset().top);
    }, 0);
  });

  /* article cart btn */
  $(window).scroll(function () {
    var footBar = 0;
    if ($(window).innerHeight() < 1000) {
      footBar = 75;
    }
    if ($("section.product_bar").length) {
      if ($(this).scrollTop() + $(window).innerHeight() > $(window).innerHeight() + footBar) {
        $("section.product_bar").addClass("on");
      } else {
        $("section.product_bar").removeClass("on");
      }
    }
  });

  /* set option */
  $('#add_option').on('change', function () {
    var $selects = $('.option_form select:not([disabled])');
    if ($(this).is(':checked')) {
      if ($selects.length === 1) {
        $selects.prop("selectedIndex", 1);
      } else {
        $selects.prop("selectedIndex", 0);
      }
    } else {
      $selects.prop("selectedIndex", 0);
    }
  });

  /* language change */
  $(".language_select").change(function () {
    if ($(this).val() != '') {
      window.location.href = $(this).val();
    }
  });

  /* video */
  if ($(".video_thumbnail").length == 1) {
    const player = new Plyr('#player', { loop: { active: true } });
    window.player = player;
    const videoWrapper = document.getElementsByClassName("plyr__video-wrapper")[0];
    videoWrapper.addEventListener("click", event => {
      player.togglePlay();
      event.stopPropagation();
    });
    player.toggleControls(false);
    $(".video_thumbnail").on("click", function () {
      player.togglePlay();
      $(this).delay(500).fadeToggle(500, "linear");
    });
  }
  if ($(".video_thumbnail").length > 1) {
    const players = Array.from(document.querySelectorAll('.howto_video')).map(p => new Plyr(p, {
      clickToPlay: true
    }));

    $(".video_thumbnail").on("click", function () {
      active = $('.video_thumbnail').index(this);
      for (let index = 0; index < players.length; index++) {
        players[index].pause();
        players[index].on('pause', function () {
          players[index].toggleControls(false);
        });
      }
      players[active].play();
      $(this).delay(500).fadeToggle(500, "linear");
    });
  }
  if ($(".main_movie.full").length > 0){
    /* const player = new Plyr('#player', { controls:['play-large', 'play', 'progress', 'mute', 'volume', 'fullscreen'] });
    let isFirstClick = true;
    player.muted = true;
    player.currentTime = 0;
    player.loop = { start: 0, end: 5 };
    player.play();
    $(".main_movie.full").addClass("mute");

    player.on('timeupdate', function () {
      if (player.currentTime >= 5 && isFirstClick) {
        player.currentTime = 0;
      }
    });
    var clickEventType = ((window.ontouchstart !== null) ? 'click' : 'touchstart');
    player.on(clickEventType, function (event) {
      if ($(event.target).hasClass('plyr__control--overlaid')) {
        if (isFirstClick) {
          $(".main_movie.full").removeClass("mute");
          player.muted = false;
          player.currentTime = 0;
          player.play();
          isFirstClick = false;
        } else if (player.touch && event.target.tagName === 'VIDEO') {
          if (player.playing) {
            player.pause();
          } else {
            player.play();
          }
        }
      }
    }); */
    const player = new Plyr('#player', { controls:['play-large', 'mute'],loop: { active: true },hideControls: false,clickToPlay: true, });
    player.muted = true;
    player.loop = true;
    player.play();
  }

  /* review */
  $(".mxpr-review__list-item-body-conent").each(function () {
    let text_count = $(this).html().length;
    if (text_count > 200) {
      var showText = $(this).html().substring(0, 150);
      var hideText = $(this).html().substring(150, text_count);
      var insertText = showText;
      insertText += '<span class="hide">' + hideText + '</span>';
      insertText += '<a class="more">... 続きを読む</a>';
      $(this).html(insertText);
      $(".hide").hide();
    }
  });
  $(document).on("click", ".mxpr-review__list-item-body-conent .more", function () {
    $(this).hide();
    $(this).prev(".hide").fadeIn();
    return false;
  });
});
